import React from 'react';

const offlinePageStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  backgroundColor: '#f8f9fa',
  textAlign: 'center',
  color: '#343a40',
  padding: '20px',
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
};

const headingStyle = {
  fontSize: '2em',
  margin: '10px 0',
};

const paragraphStyle = {
  fontSize: '1.2em',
};

const OfflinePage = () => (
  <div className="offline-page" style={offlinePageStyle}>
    <h1 style={headingStyle}>You are currently offline</h1>
    <p style={paragraphStyle}>Please check your internet connection.</p>
  </div>
);

export default OfflinePage;
